import React from 'react';
import { useTailwindBrand } from '../shared';
import { useBrandAuthConfig } from '../../Hooks/Auth/useBrandAuthConfig';
import { ENV_DECLARONS, isBrandActive } from '../../config/environment.config';

const RightContentLogin = () => {
    const { classes, common, brand } = useTailwindBrand();
    const { brandContent, brandImages } = useBrandAuthConfig()
    const currentBrandContent = brandContent[brand as keyof typeof brandContent] || brandContent.teachr;
    const currentBrandImages = brandImages[brand as keyof typeof brandImages] || brandImages.teachr;
    return (

        <div className={`w-full lg:w-1/2 relative overflow-hidden lg:block hidden bg-right-bottom bg-no-repeat /h-[calc(100vh-4rem-60px)]`}>
            {/* Image de fond avec overlay */}
            <div
                className={`absolute inset-0 bg-cover bg-center bg-no-repeat`}
                style={{
                    backgroundImage: `url(${currentBrandImages.hero}) `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                {/* Overlay avec gradient */}
                {/* <div className={`absolute inset-0 opacity-90`}></div> */}

                {/* Motif de fond */}
                <div
                    className="absolute inset-0 opacity-10"
                    style={{
                        backgroundImage: `url(${currentBrandImages.background})`,
                        backgroundSize: '200px',
                        backgroundRepeat: 'repeat'
                    }}
                ></div>
            </div>

            {/* Contenu héro */}
            <div className={`relative z-10 flex flex-col justify-center items-center text-center text-white h-full p-8 lg:p-12 ${classes.fontFamily}`}>
                <div className="max-w-lg space-y-10">
                    {currentBrandImages.img && (
                        <img
                            src={currentBrandImages.img}
                            alt={brand}
                            className={`w-[200px] h-[200px] mx-auto rounded-full p-2 ${isBrandActive(ENV_DECLARONS) ? "" : "border-4 border-white/30"} animate-pulse`}
                        />
                    )}
                    <h2 className={`mb-4 ${common.title} ${isBrandActive(ENV_DECLARONS) ? classes.primaryText : ""} leading-tight ${classes.fontFamily} drop-shadow-lg`}>
                        {currentBrandContent.heroTitle}
                    </h2>
                    <p className={`text-xl lg:text-2xl mb-8 opacity-90 font-bold ${isBrandActive(ENV_DECLARONS) ? classes.primaryText : ""} leading-relaxed ${classes.fontFamily} drop-shadow-md`}>
                        {currentBrandContent.heroSubtitle}
                    </p>
                    <div className={`inline-flex items-center gap-2 px-6 py-3 bg-white bg-opacity-20 backdrop-blur-sm rounded-full border border-white border-opacity-40 ${isBrandActive(ENV_DECLARONS) ? ` ${classes.primaryBg}` : ""} ${classes.fontFamily} shadow-lg`}>
                        <span className="text-2xl">✨</span>
                        <span className="font-semibold">{currentBrandContent.tagline}</span>
                    </div>
                </div>
            </div>

            <div className="absolute top-8 right-8 w-24 h-24 bg-white bg-opacity-10 rounded-full backdrop-blur-sm animate-pulse"></div>
            <div className="absolute bottom-8 left-8 w-16 h-16 bg-white bg-opacity-10 rounded-full backdrop-blur-sm animate-pulse delay-300"></div>
        </div>
    );
};

export default RightContentLogin;